import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenericService {
  constructor(private httpclient: HttpClient) {}

  getGenericMultiSearch(params?: HttpParams): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/generic/sharepoint/multi/search`,
      { params }
    );
  }

  getGenericFiltroLista(params?: HttpParams): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/generic/sharepoint/valid/list`,
      { params }
    );
  }

  getGenericFiltroKeywordnaLista(params?: HttpParams): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/generic/sharepoint/findContent`,
      { params }
    );
  }

  getGenericComissoesBancariasListaInstituicoesFinancieira(
    params?: HttpParams
  ): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/comissoes/bancarias/listar/instituicoes/financeiras`,
      { params }
    );
  }

  getGenericComissoesBancariasListaServicos(
    params?: HttpParams
  ): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/comissoes/bancarias/listar/servicos`,
      { params }
    );
  }
  getGenericComissoesBancariasListaProdutos(
    params?: HttpParams
  ): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/comissoes/bancarias/listar/produtos`,
      { params }
    );
  }

  getGenericComissoesBancariasListaPeriodoCobranca(
    params?: HttpParams
  ): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/comissoes/bancarias/listar/periodo/cobranca`,
      { params }
    );
  }

  getGenericCompararInstiuicao(params?: HttpParams): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/comissoes/bancarias/get/comparador/if`,
      { params }
    );
  }

  getGenericCompararServico(params?: HttpParams): Observable<any> {
    return this.httpclient.get<any>(
      `${environment.baseUrl}/rest/comissoes/bancarias/get/comparador/servico`,
      { params }
    );
  }

  getGenericv2Search(corpo?: any, headers?: HttpHeaders): Observable<any> {
    return this.httpclient.post<any>(
      `${environment.baseUrl}/rest/generic/sharepoint/v2/search`,
      corpo,
      { headers }
    );
  }

  postGenericSearch(corpo?: any, headers?: HttpHeaders): Observable<any> {
    return this.httpclient.post<any>(
      `https://www.bna.ao/service/rest/generic/sharepoint/v2/search`,
      corpo,
      { headers }
    );
  }
}
